import { render, staticRenderFns } from "./TicketSuporteFluxoCard.vue?vue&type=template&id=fcaff66e&"
import script from "./TicketSuporteFluxoCard.vue?vue&type=script&lang=js&"
export * from "./TicketSuporteFluxoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports